import 'photoswipe/style.css';

import { photoswipe } from '@/storybook/theme';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import { onUnmounted } from 'vue';

export const usePhotoSwipe = (src: string) => {
  let lightbox: PhotoSwipeLightbox | null = null;

  const init = (width?: number, height?: number) => {
    lightbox = new PhotoSwipeLightbox({
      dataSource: [
        {
          width,
          height,
          src,
        },
      ],
      arrowKeys: false,
      initialZoomLevel: 'fit',
      zoomSVG: photoswipe.zoomSVGString,
      closeSVG: photoswipe.closeSVGString,
      counter: false,
      preloadFirstSlide: true,
      bgOpacity: 0.8,
      pswpModule: () => import('photoswipe'),
    });

    lightbox?.init();
  };

  const open = () => lightbox?.loadAndOpen(0);

  onUnmounted(() => {
    if (lightbox) {
      lightbox.destroy();
      lightbox = null;
    }
  });

  return { lightbox, open, init };
};
